<template>
  <div>
    <Payment :invoice="selectedInvoice" @refresh="getList" @save="save" @closePayment="closePayment"
      :paymentDialog="paymentDialog">
    </Payment>
    <v-card v-if="location" outlined>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subtitle-1">{{ $t("pageHeader.invoice") }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12 md4>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line="single-line" hide-details
            clearable="clearable">
          </v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table :headers="headers" :items="invoice" :search="search" :loading="loading" :sort-by="sortBy"
        :page.sync="page" :items-per-page="itemsPerPage">
        <template v-slot:item="{ item }">
          <tr class="pointer">
            <td class="text-center" @click="viewInvoice(item)">
              {{ item.invoiceID }}
            </td>
            <td class="text-left" @click="viewInvoice(item)">

              <span>{{ $moment(item.createDateTime).format("L") }}</span>
              <v-chip class="ml-1" small color="#ffd0d2" v-if="item.refunded">
                <v-icon small color="red">replay</v-icon>
              </v-chip>
              <v-chip class="ml-1" small color="#dde2e6" v-else-if="item.refundAmount < 0">
                <v-icon small color="gray">replay</v-icon>
                <span class="gray--text">{{ item.refundAmount | currency }}</span>
              </v-chip>
            </td>
            <td class="text-left" v-if="item.paidDateTime" @click="viewInvoice(item)">
              <span>{{ $moment(item.paidDateTime).format("L") }}</span>
              <v-chip class="ml-1 pointer" @click="openStripe(item)" small color="#D0E9FF"
                v-if="item.stripePaymentID && item.stripePaymentID.substring(0, 3) === 'ch_'">
                <v-icon small color="#3C4DA6">credit_card</v-icon>
              </v-chip>
              <v-chip class="ml-1" small dark="dark" color="#ffd0d2" v-else>
                <v-icon small color="#ff3840">attach_money</v-icon>
              </v-chip>
            </td>
            <td class="text-left" v-else @click="viewInvoice(item)">
              <v-chip color="error" text-color="white" small>Not Paid</v-chip>
            </td>
            <td class="text-right" @click="viewInvoice(item)">
              {{ (item.invoiceAmount + item.taxAmount) | currency }}
            </td>
            <td class="justify-end layout px-0">
              <v-menu bottom="bottom" left="left">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item @click="viewInvoice(item)">
                    <v-list-item-title>{{ $t("buttons.view") }}</v-list-item-title>
                  </v-list-item>
                  <v-divider> </v-divider>
                  <v-divider> </v-divider>
                  <v-list-item @click="emailInvoice(item)">
                    <v-list-item-title>{{ $t("buttons.emailInvoice") }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
const Payment = () => import("./Payment");
import invoiceService from "../service.js";
import { mapGetters } from "vuex";
import { close } from "fs";

export default {
  data() {
    return {
      paymentDialog: false,
      invoiceID: 0,
      sortBy: "createdAt",
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      headers: [
        {
          text: this.$t("labels.invoiceNumber"),
          value: "invoiceID",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("labels.createdAt"),
          value: "createDateTime",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("labels.paidDate"),
          value: "paidDateTime",
          align: "center",
          sortable: true
        },
        {
          text: this.$t("labels.invoiceAmount"),
          value: "invoiceAmount",
          align: "center",
          sortable: true
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ],
      search: null,
      refundDialog: false,
      selectedInvoice: null,
      invoice: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "invoiceID",
        descending: true
      }
    };
  },
  computed: {
    ...mapGetters("location", ["location"]),
    ...mapGetters("global", ["currentUser"])
  },
  created() {
    this.getList();
  },
  components: {
    Payment
  },
  methods: {
    emailInvoice(val) {
      this.$swal({
        title: "Are you sure?",
        text: "You want to email this invoice?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          return invoiceService
            .emailInvoice(val.invoiceID, { email: this.location.invoiceEmail })
            .then(response => {
              console.log("email response", response);
              if (response.data) {
                this.$swal
                  .mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000
                  })
                  .fire({
                    type: "success",
                    title: "Email was send successfully"
                  });
                this.$Progress.finish();
              }
            })
            .catch(error => {
              this.$toasted.error(error.data.message, {
                position: "top-right",
                showHideTransition: "slide",
                icon: "error",
                duration: 5000
              });
              this.$Progress.fail();
            });
        }
      });
    },
    save() {
      this.closePayment();
      this.getList();
    },
    closePayment() {
      this.paymentDialog = false;
    },
    makePayment(val) {
      this.paymentDialog = true;
      this.selectedInvoice = val;
    },
    viewInvoice(data) {
      // this.$router.push({path: `/global/invoice/${data.invoiceID}/view`});
      let routeData = this.$router.resolve({
        path: `/global/invoice/${data.invoiceID}/view`
      });
      window.open(routeData.href, "newwindow", "width=800, height=950");
    },
    getList() {
      this.loading = true;
      console.log("this.location", this.location);
      return invoiceService.getById(this.location.storeID).then(response => {
        console.log("response response", response);
        this.invoice = response.data;
        this.loading = false;
        return response;
      });
    }
  }
};
</script>
